import FriendlyDateTime from './FriendlyDateTime';
import JobData, { JobDataClassProps, JobDataInterface } from './JobData';

export type JobClassProps = {
    created_at: string;
    data: JobDataClassProps;
    finished_at: string;
    job_id: string;
    started_at: string;
    status: string;
    type: string;
    messages: string[];
};

export interface JobInterface {
    createdAt: string;
    data: JobDataInterface;
    finishedAt: string;
    jobId: string;
    startedAt: string;
    status: string;
    type: string;
    messages: string[];
    created_at: string;
}

export const STATUS_OK = 'JOB_STATUS_CREATED';
export const STATUS_ERROR = 'JOB_STATUS_ERRORED';
export const STATUS_RUNNING = 'JOB_STATUS_RUNNING';

export const TYPE_ADD = 'JOB_TYPE_ADD_NODE';
export const TYPE_REMOVE = 'JOB_TYPE_REMOVE_NODE';
export const TYPE_VOLUME_SIZE = 'JOB_TYPE_VOLUME_SIZE';
export const TYPE_PROMOTE_REPLICA = 'JOB_TYPE_PROMOTE_REPLICA';

export default class Job implements JobInterface {
    readonly createdAt: string;
    readonly data: JobDataInterface;
    readonly finishedAt: string;
    readonly jobId: string;
    readonly startedAt: string;
    readonly status: string;
    readonly type: string;
    readonly messages: string[];
    readonly created_at: string;

    constructor(props: JobClassProps) {
        this.createdAt = new FriendlyDateTime({
            date: props.created_at,
        }).getFriendlyDate();
        this.data = new JobData(props.data);
        this.finishedAt = props.finished_at;
        this.jobId = props.job_id;
        this.startedAt = props.started_at;
        this.status = props.status;
        this.type = props.type;
        this.messages = props.messages || [];
        this.created_at = new FriendlyDateTime({
            date: props.created_at,
        }).getFullDate();
    }

    isStatusOk() {
        return this.status.toUpperCase() === STATUS_OK;
    }

    isStatusError() {
        return this.status.toUpperCase() === STATUS_ERROR;
    }

    isStatusRunning() {
        return this.status.toUpperCase() === STATUS_RUNNING;
    }

    isAddNode() {
        return this.type.toUpperCase() === TYPE_ADD;
    }

    isRemoveNode() {
        return this.type.toUpperCase() === TYPE_REMOVE;
    }

    isVolumeScale() {
        return this.type.toUpperCase() === TYPE_VOLUME_SIZE;
    }
}
